/** @jsx jsx */

import { useContext } from 'react';
import type { CaptionElementProps } from 'react-day-picker';
import { format } from 'date-fns';
import { jsx } from '@balance-web/core';

import { CalendarCaptionButtons } from './CalendarCaptionButtons';
import { CalendarViewContext } from './CalendarViewContext';

export const CalendarCaption = ({ classNames, date }: CaptionElementProps) => {
  const calendarView = useContext(CalendarViewContext);

  return (
    <div aria-live="polite" className={classNames.caption} role="heading">
      <div>
        {calendarView ? (
          <CalendarCaptionButtons
            month={date}
            onPeriodClick={(period, trigger) => {
              calendarView.openPeriodView(period, date, trigger);
            }}
          />
        ) : (
          format(date, 'MMMM yyyy')
        )}
      </div>
    </div>
  );
};
